import { ReactComponent as PlusCircle } from '../../../../assets/icons/plus-circle.svg';
import { ReactComponent as MinusCircle } from '../../../../assets/icons/minus-circle.svg';
import SvgConverter from '../../../../views/components/Common/SvgConverter';

export const HelpCenterCollapseButton = ({ isActive = false }) => {
  const Icon = isActive ? MinusCircle : PlusCircle;

  return <SvgConverter Icon={Icon} color="none" />;
};
